import { 
  fetchUserTypes, 
  fetchTenantMenu,
  subTenantOutline,
  fetchTenantHasMenu,
  fetchTenantOutline, 
  fetchTenantHasOutline, 
  fetchTenantHasShowMenu,
  subBatchTenantOutline,
  subTenantNoHasMenu,
  subBatchTenantMenu,
  subBatchTenantCancelMenu,
  subTenantMissCheckOutline,
  subBatchTenantCancelOutline,
  checkUserTenantTree,
  checkTenantTree
} from '../services';
import { MSG, responseErrorHandle } from 'src/common/constants';
import { fetchAllTenantData } from '@/components/TenantTree/service';
import _ from 'lodash';

/** 
 * 格式化租户树
 */
export const formatTenantTrees = (list) => {
  if (!Array.isArray(list)) {
    return [];
  }

  return list?.map((item = {}) => {
    const { code, name, children, key, title } = item;

    item.key = code || key;
    item.title = name || title;
    
    if (children && !!children.length) {
      formatTenantTrees(children);
    }

    return item;
  });
};

/**
 * 全部展开
 * @param {*} data
 * @returns
 */
const convertTree = (data) => {
  return (
    Array.isArray(data) &&
    data.reduce((pre, cur) => {
      const { children = [] } = cur;
      return pre.concat([cur], convertTree(children || []));
    }, [])
  );
};

/**
 * 过滤掉全部的子节点
 * @param {*} data
 * @returns
 */
const filterChild = (data) => {
  return Array.isArray(data) && data.filter((item) => item.leaf);
};


export default {
  namespace: 'tenantTab',

  state: {
    tenantTrees: [], // 全量的租户树列表
    selectedOutlineTreeKeys: ['nodata'], // 全部功能树选中的 keys
    selectedMenuTreeKeys: ['nodata'], // 全部菜单树险种keys
    isEditable: false, // 全部菜单是否可编辑
    cleanCheckedKeys: false, // 清楚选中内容
    isBatchEditable: false, // 批量操作
    isEditing: false, // 编辑状态控制，会在首次点击后变更
    overwrite: false, // 订购模式，是否需要全量覆盖
    isBatchCancelEditable: false, // 批量取消操作
    tenantCanUseOutline: [], // 组合可订阅功能列表
    tenantCanUseMenu: [], // 组合可订阅菜单列表
    allUserTypes: [], // 全量用户类别
    selectedUseType: '01', // 选中用户类别
    tenantOutline: [], // 组合订阅功能
    tenantMenu: [], // 租户订购菜单
    tenantHasMenu: [], // 租户订购已有菜单
    tenantCheckboxKeys: [], // 租户批量选择数据，
    submitTenantOutline: [], // 提交数据
    submitTenantMenu: [], // 菜单提交数据
    tenantData: '', // 选择租户数据
    allData: [], // 全量树数据
    allOutlineChildKey: [], // 全量功能树的所有的子节点
    allMenuChildKey: [], // 全量菜单树的所有的子节点
    notClear: true, // 控制清除按钮 
  },

  effects: {
    /** 
     * 查询全量的租户树列表
     */
    * queryAllTenantTrees ({ payload = {} }, { call, put }) {
      const result = yield call(fetchAllTenantData, payload);
      // const { success, result, message } = res || {};
      
      // if (!success || !Array.isArray(result)) {
      //   return responseErrorHandle(message || MSG.DEFAULT);
      // }
      const tenantTrees = formatTenantTrees(result);
      yield put({
        type: 'updateState',
        tenantTrees,
      });
    },
    * queryTenantCanUseOutline ({ payload = {} }, { call, put }) {
      const res = yield call(fetchTenantOutline, payload);
      const { success, result, message } = res || {};
      
      if (!success || !Array.isArray(result)) {
        return responseErrorHandle(message || MSG.DEFAULT);
      }

      yield put({
        type: 'updateState',
        tenantCanUseOutline: formatTenantTrees(result),
        allOutlineChildKey: _.flow([convertTree, filterChild])(result),
      });
    },
    * queryTenantCanUseMenu ({ payload = {} }, { call, put }) {
      const res = yield call(fetchTenantMenu, payload);
      const { success, result, message } = res || {};

      if (!success || !Array.isArray(result)) {
        return responseErrorHandle(message || MSG.DEFAULT);
      }
      yield put({
        type: 'updateState',
        tenantCanUseMenu: formatTenantTrees(result),
        allMenuChildKey: _.flow([convertTree, filterChild])(result),
      });
    },
    * queryTenantHasShowMenu ({ payload = {} }, { call, put }) {
      const res = yield call(fetchTenantHasShowMenu, payload);
      const { success, result, message } = res || {};

      if (!success || !Array.isArray(result)) {
        return responseErrorHandle(message || MSG.DEFAULT);
      }
      yield put({
        type: 'updateState',
        tenantHasMenu: result,
      });
    },
    
    * queryAllUserTypes ({ payload = {} }, { call, put }) {
      const res = yield call(fetchUserTypes, payload);
      const { success, result, message } = res || {};
    
      if (!success || !Array.isArray(result)) {
        return responseErrorHandle(message || MSG.DEFAULT);
      }

      yield put({
        type: 'updateState',
        allUserTypes: formatTenantTrees(result),
      });
    },
    * queryTenantHasOutline ({ payload = {} }, { call }) {
      const res = yield call(fetchTenantHasOutline, payload);
      const { success, result, message } = res || {};
  
      if (!success || !Array.isArray(result)) {
        responseErrorHandle(message || MSG.DEFAULT);
        return [];
      }

      // yield put({
      //   type: 'updateState',
      //   tenantOutline: result.length ? result : [],
      // });
      return result || [];
    },
    * queryTenantHasMenu ({ payload = {} }, { call }) {
      const res = yield call(fetchTenantHasMenu, payload);
      const { success, result, message } = res || {};

      if (!success || !Array.isArray(result)) {
        responseErrorHandle(message || MSG.DEFAULT);
        return [];
      }

      // yield put({
      //   type: 'updateState',
      //   tenantOutline: result.length ? result : [],
      // });
      return result || [];
    },
    * toSubTenantOutline ({ payload = {} }, { call }) {
      const res = yield call(subTenantOutline, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },
    * toSubBatchTenantOutline ({ payload = {} }, { call }) {
      const res = yield call(subBatchTenantOutline, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },
    * toSubBatchTenantCancelOutline ({ payload = {} }, { call }) {
      const res = yield call(subBatchTenantCancelOutline, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },
    * toSubTenantNoHasMenu ({ payload = {} }, { call }) {
      const res = yield call(subTenantNoHasMenu, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },
    * toSubBatchTenantMenu ({ payload = {} }, { call }) {
      const res = yield call(subBatchTenantMenu, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },
    * toSubBatchTenantCancelMenu ({ payload = {} }, { call }) {
      const res = yield call(subBatchTenantCancelMenu, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },
    * toSubTenantMissCheckOutline ({ payload = {} }, { call }) {
      const res = yield call(subTenantMissCheckOutline, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },

    * checkTenantTree ({ payload = {} }, { call }) {
      const res = yield call(checkTenantTree, payload);
      const { success, message, result } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return result;
    },

    * checkUserTenantTree ({ payload = {} }, { call }) {
      const res = yield call(checkUserTenantTree, payload);
      const { success, message, result } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return result;
    },
  },

  reducers: {
    /** 
     * 通用的更新状态的方法
     */
    updateState (state, params) {
      const { ...rest } = params || {};
      return {
        ...state,
        ...rest,
      };
    },
  },
};

